import React from "react";
import "./button.css";
import { toTestId } from "../../utils/testId";

const LOADING_LABELS: Record<string, string> = {
  "Save":             "Saving...",
  "Submit":           "Submitting...",
  "Update":           "Updating...",
  "Delete":           "Deleting...",
  "Create":           "Creating...",
  "Login":            "Logging in...",
  "Sign":             "Signing...",
  "Sign Application": "Signing...",
  "Upload":           "Uploading...",
  "Upload Images":    "Uploading...",
  "Apply":            "Applying...",
  "Apply Now":        "Applying...",
  "Post":             "Posting...",
  "Post Payment":     "Posting...",
  "Add":              "Adding...",
  "Add Estimate":     "Adding...",
  "Mark As Fixed":    "Processing...",
  "Approve":          "Approving...",
  "Reject":           "Rejecting...",
};

const getLoadingLabel = (label: string): string =>
  LOADING_LABELS[label] ?? `${label}...`;

interface SimpleButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  form?: string;
  background?: string;
  className?: string;
  width?: string;
  padding?: string;
  style?: React.CSSProperties;
  isDisabled?: boolean;
  isLoading?: boolean;
  /** Optional stable automation hook, surfaced as data-testid. Falls back to a slug of the label. */
  testId?: string;
}

const SimpleButton: React.FC<SimpleButtonProps> = ({
  label,
  onClick,
  type = "button",
  form,
  background,
  padding,
  className = "",
  style = {},
  isDisabled = false,
  isLoading = false,
  width = "auto",
  testId,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      form={form}
      data-testid={testId ?? `btn-${toTestId(label)}`}
      className={`btn-simple-primary ${className}`}
      style={{
        background,
        padding,
        width,
        ...style,
      }}
      disabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <>
          <span className="btn-spinner" aria-hidden="true" />
          {getLoadingLabel(label)}
        </>
      ) : (
        label
      )}
    </button>
  );
};

export default SimpleButton;
